// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"910":"1207989c","1074":"8386b4d0"}[chunkId] + ".chunk.css";
};